import Vue from 'vue'
import {sync} from 'vuex-router-sync'
import App from 'components/App'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueProgressBar from 'vue-progressbar'
sync(store, router)

const progressBarOptions = {
  color: '#286090',
  failedColor: '#c9302c',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s'
},
autoRevert: true
}


Vue.use(VueProgressBar, progressBarOptions)

axios.interceptors.request.use(function (config) {
    store.commit('CURSOR_UPDATED', 'wait');
    return config;
}, function (err) {
    store.commit('CURSOR_UPDATED', '');
    return Promise.reject(err);
});

axios.interceptors.response.use((response) => {
    store.commit('CURSOR_UPDATED', '');
    return response;
}, (err) => {
    store.commit('CURSOR_UPDATED', '');
    // Vue.$Progress.fail();
    if (err.response.status == 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        store.commit('BAD_CREDENTIALS_UPDATED', true);
    }
    else if (err.response.status == 403) {
        store.commit('ACCESS_DENIED_UPDATED', true);
        router.push('/');
    }
    return Promise.reject(err);
});

Vue.use(VueAxios, axios)


const app = new Vue({
    router,
    store,
    ...App
})

app.$mount('#app')

export {app, router, store}